import React from 'react';
import {
  EarnCreditSettingsModule,
  FreemiumSettingsModule,
  TagSettingsModule
} from './modules';
import { GetFullSettings } from '../../../graphql/Query';
import { useQuery } from '@apollo/client';

const GeneralSettings = () => {
  const { data, loading } = useQuery(GetFullSettings, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first'
  });

  if (loading) return null;

  return (
    <div>
      <FreemiumSettingsModule data={data?.getFullSettings?.freemiumInfo} />
      <TagSettingsModule data={data?.getFullSettings?.tags} />
      <EarnCreditSettingsModule data={data?.getFullSettings?.earnCreditInfo} />
    </div>
  );
};

export default GeneralSettings;
